import classNames from 'classnames';
import type { FC } from 'react';
import {
  getAriaButtonRoleAttribute,
  handleAccessibleButtonKeyDown,
} from '../Button/ariaHelpers';
import { Tooltip, type TooltipChildNode } from '../Tooltip/Tooltip';

interface Props {
  children: TooltipChildNode;
  description?: string;
  focused?: boolean;
  onClick: () => void;
  selected: boolean;
  severity?: string;
}

export const Option: FC<Props> = (props) => (
  <div
    className={classNames(
      'flex flex-col items-center justify-center cursor-pointer',
      // the subtracted border is on the parent dropdown container (left/right border), so we can't use subtract-border utility here
      'w-full h-7 px-[calc(theme(padding.2xs)-theme(borderWidth.DEFAULT))] py-2xs',
      'hover:bg-state-hover',
      props.focused && 'bg-state-hover',
      props.selected && 'bg-state-press',
    )}
    onClick={props.onClick}
    {...getAriaButtonRoleAttribute()}
    tabIndex={0}
    onKeyDown={(e) => {
      handleAccessibleButtonKeyDown(e, false);
    }}
    aria-label={`Severity option ${props.severity ?? props.description}`}
  >
    <Tooltip headline={props.description}>{props.children}</Tooltip>
  </div>
);
